<template>
  <Grid gtc="1fr 32px 1fr 32px 1fr" justify-content="start">
    <template v-for="(label, index) of labels">
      <div v-if="label.separator" :key="`separator-${index}`" class="separator q-mx-md"></div>

      <Grid
        v-else
        :key="`section-${index}`"
        gtc="auto 1fr"
        justify-content="start"
        align-items="center"
        align-content="start"
        gap="0 var(--r-space-lg)"
      >
        <template v-for="item of label.items">
          <div :key="`label-${item.label}`" class="text-body-1 text-secondary-1">{{ item.label }}</div>

          <Grid
            :key="`value-${item.label}`"
            gaf="column"
            align-items="center"
            justify-content="start"
            class="label-value"
          >
            <RInfo :to="item.to" :text="item.value" v-bind="item" class="ellipsis" />

            <div v-if="item.editable">
              <EditIcon class="q-ml-sm q-mt-xs cursor-pointer edit-icon" />

              <EditPopup :item="item" @update="$emit('update', $event)" />
            </div>
          </Grid>
        </template>
      </Grid>
    </template>
  </Grid>
</template>

<script>
// Libraries
// Components
import RInfo from '@/ui/RInfo'
import EditIcon from '@/ui/icons/EditIcon'
import EditPopup from './EditPopup'

export default {
  components: {
    RInfo,
    EditIcon,
    EditPopup
  },

  props: {
    labels: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.separator {
  width: 1px;
  border: 1px solid var(--r-white-4);
  height: 100%;
}

.label-value {
  .edit-icon {
    visibility: hidden;
  }

  &:hover .edit-icon {
    visibility: visible;
  }
}
</style>
